module.exports = __webpack_public_path__ + "img/circle-waveform-lines.e944efe7.svg";